import { Heart, Globe, Network, Brain, Cross, Layers } from "lucide-react";
import { Reveal, SectionLabel } from "@/components/Reveal";

const APPROCHES = [
  { icon: Heart, title: "Humaniste", text: "Vous êtes au centre de la démarche, avec respect, compassion et confiance en votre potentiel." },
  { icon: Globe, title: "Globale", text: "J'aborde toutes les dimensions de votre être : physique, mentale, émotionnelle, relationnelle et spirituelle." },
  { icon: Network, title: "Systémique", text: "Je considère votre histoire et vos relations pour mieux comprendre ce qui influence votre vie." },
  { icon: Brain, title: "En profondeur", text: "Nous travaillons sur les causes racines afin d'obtenir des changements durables et significatifs." },
  { icon: Cross, title: "Spirituelle chrétienne", text: "Votre foi peut être intégrée à votre démarche, lorsque vous le souhaitez. Prière, réflexion, discernement et guérison peuvent être des ressources précieuses." },
  { icon: Layers, title: "Intégrative", text: "J'utilise différentes techniques reconnues adaptées à vos besoins et à vos objectifs." },
];

export default function Approches() {
  return (
    <section data-testid="approches-section" className="bg-sand/40">
      <div className="mx-auto max-w-[1500px] px-6 py-24 md:px-12 md:py-32 lg:px-24">
        <Reveal>
          <SectionLabel>Notre approche</SectionLabel>
          <h2 className="mt-8 max-w-3xl font-serif text-4xl font-light leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl">
            Une approche globale, <em className="text-sage-dark">profonde</em> et <em className="text-sage-dark">intégrative</em>
          </h2>
          <p className="mt-8 max-w-2xl text-lg leading-relaxed text-deep/70">
            Je vous accompagne pour comprendre ce qui vous limite, transformer ce qui vous freine et vous rapprocher de la vie que vous désirez.
          </p>
          <p className="mt-4 text-xs uppercase tracking-[0.3em] text-gold">Corps • Âme • Esprit</p>
        </Reveal>

        <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {APPROCHES.map((a, i) => (
            <Reveal key={a.title} delay={(i % 3) * 0.08}>
              <div data-testid={`approche-${i + 1}`} className="flex h-full items-start gap-5 rounded-3xl border border-deep/10 bg-white/50 p-7 transition-colors duration-500 hover:border-gold/40">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-gold/15">
                  <a.icon className="h-5 w-5 text-gold" />
                </span>
                <div>
                  <h3 className="font-serif text-xl font-light uppercase tracking-wide text-deep">{a.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-deep/60">{a.text}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
